export default __webpack_public_path__ + "static/media/logos_c-sharp.90725711.svg";